<div class="generic-filters">
  <div *ngIf="!filters.showFilters && !isDesktopWidth">
    <button siPreventDoubleClick class="w-100 align-items-center justify-content-center" [ngClass]="showMoreButtonClass"
            (click)="showMoreFilters()">
      <i class="generic-filters_icon mr-2" [ngClass]="showMoreButtonIcon"></i>
      <span>{{'SI_SHOW_FILTERS' | translate}}</span>
      <span>&nbsp;({{activeFiltersCount}})</span>
    </button>
  </div>
  <div [hidden]="!filters.showFilters && !isDesktopWidth"
       siStorage
       siStorageName="{{name}}Storage"
       [siStorageModel]="filters"
       (siStorageModelChange)="onSiStorageModelChange($event)"
       (siStorageNoItemChange)="onSiStorageNoItemChange()"
       [siStorageManualSet]="filtersStorageManualSet">
    <div [ngClass]="cardClass">
      <div class="row pasi-gap-v-10">
        <ng-content></ng-content>
        <div class="col-12 col-sm-auto d-flex flex-column justify-content-center ml-auto">
          <div class="row pasi-gap-v-10">
            <div class="col-6 col-sm-auto">
              <button siPreventDoubleClick
                      class="w-100"
                      [ngClass]="clearButtonClass"
                      translate="SI_CLEAR"
                      type="button"
                      (click)="onClickClearFilters()"
              ></button>
            </div>
            <div class="col-6 col-sm-auto">
              <button siPreventDoubleClick
                      class="w-100"
                      [ngClass]="filterButtonClass"
                      translate="SI_FILTER"
                      type="submit"
                      (click)="onSubmit()"
                      [disabled]="form?.invalid"
              ></button>
            </div>
            <div *ngIf="!isDesktopWidth"
                 class="col-12 col-sm-auto order-sm-first">
              <button siPreventDoubleClick
                      class="w-100"
                      [ngClass]="showFewerButtonClass"
                      translate="SI_CLOSE_FILTERS"
                      type="button"
                      (click)="closeFilters()"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
